import { ReactNode } from "react"
import { PortalContainer } from "./main/Portal"
import { BaseDialogTypeType } from "../../biz/data/redux/uIReducer"
import { FormButtonIconType, Padder, SimpleButton } from "./Simple/SimpleElements"

type DialogType = {
    type?: BaseDialogTypeType,
    visible: boolean,
    children: ReactNode,
    header?: string,
    onOk?(): void,
    onCancel?(): void,
    okText?: string,
    okIcon?: FormButtonIconType,
    cancelText?: string
    clickOutside?(): void
    okDisabled?: boolean
    className?: string
}

export const Dialog = (
    { type, visible, children, header, onOk, onCancel, okText, okIcon, cancelText, clickOutside, okDisabled, className }: DialogType) => {
    return (
        <PortalContainer visible={visible} clickOutside={clickOutside}>
            <div className={"dialog" + (!!className ? " " + className : "")}>

                {type === "info" && (<InfoIco />)}
                {type === "warning" && (<WarningIco />)}
                {type === "input-link" && (<LinkIco />)}
                {type === "add" && (<AddIco />)}

                <div className="dialog-header">
                    {header}
                </div>

                <div className="dialog-content">
                    {children}
                </div>

                <div className="dismiss" onClick={clickOutside}>
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.4805 7.85156L13.793 12.5391L18.4414 17.1875C18.832 17.5391 18.832 18.125 18.4414 18.4766C18.0898 18.8672 17.5039 18.8672 17.1523 18.4766L12.4648 13.8281L7.81641 18.4766C7.46484 18.8672 6.87891 18.8672 6.52734 18.4766C6.13672 18.125 6.13672 17.5391 6.52734 17.1484L11.1758 12.5L6.52734 7.85156C6.13672 7.5 6.13672 6.91406 6.52734 6.52344C6.87891 6.17188 7.46484 6.17188 7.85547 6.52344L12.5039 11.2109L17.1523 6.5625C17.5039 6.17188 18.0898 6.17188 18.4805 6.5625C18.832 6.91406 18.832 7.5 18.4805 7.85156Z" fill="#9F8E73" />
                    </svg>

                </div>

                {type === "info" && (
                    <div>
                        <Padder heightPx={32} />
                        <SimpleButton
                            onClick={() => { if (!!clickOutside) clickOutside(); }}
                            label={!okText ? "Ok" : okText}
                            type="dialog-info"
                            icon={okIcon}
                        />
                    </div>
                )}

                {type === "warning" && (
                    <div>
                        <Padder heightPx={32} />
                        <SimpleButton
                            onClick={() => { if (!!clickOutside) clickOutside(); }}
                            label={!okText ? "Ok" : okText}
                            type="dialog-warning"
                        />
                    </div>
                )}

                {type === "confirm" && (
                    <>
                        <Padder heightPx={32} />
                        <div className="dialog-buttons">
                            <div>
                                <SimpleButton
                                    onClick={() => { if (!!onCancel) { onCancel() } }}
                                    label={!cancelText ? "Avbryt" : cancelText}
                                    type="tertiarybeige50"
                                    shape="bigpill"
                                />
                            </div>

                            <div>
                                <SimpleButton
                                    onClick={() => { if (!!onOk) { onOk() } }}
                                    label={!okText ? "Ok" : okText}
                                    type="primary"
                                    shape="bigpill"
                                />
                            </div>
                        </div>
                    </>
                )}


                {type === "input-link" && (
                    <>
                        <Padder heightPx={32} />
                        <div className="dialog-buttons">
                            <div>
                                <SimpleButton
                                    onClick={() => { if (!!onCancel) { onCancel() } }}
                                    label={!cancelText ? "Avbryt" : cancelText}
                                    type="dialog-info"
                                />
                            </div>
                            <div>
                                <SimpleButton
                                    onClick={() => { if (!!onOk) { onOk() } }}
                                    label={!okText ? "Ok" : okText}
                                    type="primary"
                                    disabled={okDisabled}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </PortalContainer>
    )
}

const InfoIco = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.0234 5.25C11.5078 5.25 8.32031 7.125 6.53906 10.125C4.80469 13.1719 4.80469 16.875 6.53906 19.875C8.32031 22.9219 11.5078 24.75 15.0234 24.75C18.4922 24.75 21.6797 22.9219 23.4609 19.875C25.1953 16.875 25.1953 13.1719 23.4609 10.125C21.6797 7.125 18.4922 5.25 15.0234 5.25ZM15.0234 27C10.7109 27 6.77344 24.75 4.61719 21C2.46094 17.2969 2.46094 12.75 4.61719 9C6.77344 5.29688 10.7109 3 15.0234 3C19.2891 3 23.2266 5.29688 25.3828 9C27.5391 12.75 27.5391 17.2969 25.3828 21C23.2266 24.75 19.2891 27 15.0234 27ZM13.1484 18.75H14.2734V15.75H13.1484C12.4922 15.75 12.0234 15.2812 12.0234 14.625C12.0234 14.0156 12.4922 13.5 13.1484 13.5H15.3984C16.0078 13.5 16.5234 14.0156 16.5234 14.625V18.75H16.8984C17.5078 18.75 18.0234 19.2656 18.0234 19.875C18.0234 20.5312 17.5078 21 16.8984 21H13.1484C12.4922 21 12.0234 20.5312 12.0234 19.875C12.0234 19.2656 12.4922 18.75 13.1484 18.75ZM15.0234 12C14.1797 12 13.5234 11.3438 13.5234 10.5C13.5234 9.70312 14.1797 9 15.0234 9C15.8203 9 16.5234 9.70312 16.5234 10.5C16.5234 11.3438 15.8203 12 15.0234 12Z" fill="#9F8E73" />
        </svg>
    )
}
const WarningIco = () => {
    return (
        <svg width="50" height="36" viewBox="0 0 50 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 3C19.6094 3 14.6875 5.89062 11.9531 10.5C9.29688 15.1875 9.29688 20.8906 11.9531 25.5C14.6875 30.1875 19.6094 33 25 33C30.3125 33 35.2344 30.1875 37.9688 25.5C40.625 20.8906 40.625 15.1875 37.9688 10.5C35.2344 5.89062 30.3125 3 25 3ZM25 35.5C18.6719 35.5 12.9688 32.2188 9.84375 26.75C6.64062 21.3594 6.64062 14.7188 9.84375 9.25C12.9688 3.85938 18.6719 0.5 25 0.5C31.25 0.5 36.9531 3.85938 40.0781 9.25C43.2812 14.7188 43.2812 21.3594 40.0781 26.75C36.9531 32.2188 31.25 35.5 25 35.5ZM26.25 9.25V19.25C26.25 19.9531 25.625 20.5 25 20.5C24.2969 20.5 23.75 19.9531 23.75 19.25V9.25C23.75 8.625 24.2969 8 25 8C25.625 8 26.25 8.625 26.25 9.25ZM25 27.375C23.9062 27.375 23.125 26.5938 23.125 25.5C23.125 24.4844 23.9062 23.625 25 23.625C26.0156 23.625 26.875 24.4844 26.875 25.5C26.875 26.5938 26.0156 27.375 25 27.375ZM6.01562 5.89062C3.75 9.40625 2.5 13.5469 2.5 18C2.5 22.5312 3.75 26.6719 6.01562 30.1875C6.40625 30.7344 6.25 31.5156 5.625 31.9062C5.07812 32.2969 4.29688 32.1406 3.90625 31.5156C1.40625 27.6094 0 23 0 18C0 13.0781 1.40625 8.46875 3.90625 4.5625C4.29688 3.9375 5.07812 3.78125 5.625 4.17188C6.25 4.5625 6.40625 5.34375 6.01562 5.89062ZM46.0156 4.5625C48.5156 8.46875 50 13.0781 50 18C50 23 48.5156 27.6094 46.0156 31.5156C45.625 32.1406 44.8438 32.2969 44.2969 31.9062C43.6719 31.5156 43.5156 30.7344 43.9062 30.1875C46.1719 26.6719 47.5 22.5312 47.5 18C47.5 13.5469 46.1719 9.40625 43.9062 5.89062C43.5156 5.34375 43.75 4.5625 44.2969 4.17188C44.8438 3.78125 45.625 3.9375 46.0156 4.5625Z" fill="#A74959" />
        </svg>

    )
}
const LinkIco = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.2767 26.4691H29.5228C28.7689 26.4691 28.0149 25.7152 28.1657 24.8105C28.3165 23.9058 28.9196 23.3026 29.8243 23.4534C31.3322 23.6042 32.8401 23.001 33.8956 21.9455L37.6651 18.1759C39.6253 16.2157 39.6253 13.0492 37.6651 10.9382L37.2128 10.4859C35.2526 8.52566 32.0861 8.52566 29.9751 10.4859L26.2055 14.2555C25.15 15.311 24.6976 16.8188 24.6976 18.3267C24.6976 19.2314 24.0945 19.8345 23.3406 19.9853C22.5867 19.9853 21.8327 19.3822 21.6819 18.6283C21.5311 16.2157 22.2851 13.9539 23.9437 12.1445L27.7133 8.37487C30.8798 5.20838 36.0065 5.20838 39.173 8.37487L39.6254 8.82722C42.7919 11.9937 42.7919 17.1204 39.6254 20.2869L35.8557 24.0565C34.4987 25.7152 32.3877 26.4691 30.2767 26.4691Z" fill="#CE9882" />
            <path d="M17.3087 32.5002C16.8563 32.5002 16.5547 32.3494 16.2531 32.0479C15.65 31.4447 15.65 30.54 16.2531 29.9369L29.3715 16.8186C29.9746 16.2154 30.8793 16.2154 31.4825 16.8186C32.0856 17.4217 32.0856 18.3264 31.4825 18.9296L18.3641 32.0479C18.0626 32.3494 17.6102 32.5002 17.3087 32.5002Z" fill="#CE9882" />
            <path d="M8.86491 39.7382C10.5236 41.3968 12.4837 42.1508 14.5947 42.1508C16.7057 42.1508 18.666 41.3969 20.4754 39.889L24.245 36.1194C25.9037 34.3099 26.6576 32.0482 26.5068 29.6356C26.356 28.8817 25.6021 28.2785 24.8482 28.2785C24.0942 28.4293 23.4911 29.0324 23.4911 29.9372C23.4911 31.445 23.0387 32.9529 21.9833 34.0084L18.2136 37.778C16.1026 39.7382 12.9361 39.7382 10.9759 37.778L10.5236 37.3256C9.46806 36.2701 9.01571 35.0639 9.01571 33.7068C9.01571 32.3497 9.61885 30.9927 10.5236 30.088L14.2932 26.3183C15.3487 25.2628 16.8565 24.6597 18.3644 24.8105C19.2691 24.9613 20.023 24.3581 20.023 23.4534C20.1738 22.5487 19.4199 21.7948 18.666 21.7948C16.2534 21.4932 13.8408 22.3979 12.1822 24.0565L8.41257 27.8262C6.90472 29.334 6 31.445 6 33.556C6 35.667 6.90472 37.778 8.41257 39.2859L8.86491 39.7382Z" fill="#CE9882" />
        </svg>
    )
}
const AddIco = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M25.875 13.875C26.4844 13.875 27 14.3906 27 15C27 15.6562 26.4844 16.125 25.875 16.125H16.125V25.875C16.125 26.5312 15.6094 27 15 27C14.3438 27 13.875 26.5312 13.875 25.875V16.125H4.125C3.46875 16.125 3 15.6562 3 15C3 14.3906 3.46875 13.875 4.125 13.875H13.875V4.125C13.875 3.51562 14.3438 3 15 3C15.6094 3 16.125 3.51562 16.125 4.125V13.875H25.875Z" fill="#9F8E73" />
        </svg>
    )
}